export default __webpack_public_path__ + "static/media/Background.7ce92819.png";